<template>
  <sec-page :faq="FAQS.services.items">
    <sec-hero centered :title="s.hero.title" :lede="s.hero.lede" />
    <front-door-section />
    <ladder-section />
    <pricing-section />
    <boundaries-section />
    <sec-section labelledby="faq-services" :divider="false">
      <sec-faq
        heading-id="faq-services"
        :eyebrow="FAQS.services.eyebrow"
        :title="FAQS.services.title"
        :items="FAQS.services.items"
      />
    </sec-section>
    <get-in-touch-section heading-id="services-get-in-touch" />
  </sec-page>
</template>

<script setup>
// Services: the five engagements, with the one week assessment as the front door.
import SecPage from '@/components/security/ui/SecPage.vue';
import SecHero from '@/components/security/ui/SecHero.vue';
import SecSection from '@/components/security/ui/SecSection.vue';
import SecFaq from '@/components/security/ui/SecFaq.vue';
import GetInTouchSection from '../shared/GetInTouchSection.vue';
import FrontDoorSection from './Sections/FrontDoorSection.vue';
import LadderSection from './Sections/LadderSection.vue';
import PricingSection from './Sections/PricingSection.vue';
import BoundariesSection from './Sections/BoundariesSection.vue';
import { SERVICES } from '@/content/security/services';
import { FAQS } from '@/content/security/faqs';

const s = SERVICES;
</script>
